import * as React from "react";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";

import { AutoCompleteInput } from ".";
import { IAutoComplete } from "./autoCompleteInput";

export interface BasicSelectProps extends Omit<
  IAutoComplete,
  "onSelectItem" | "options"
> {
  label?: string;
  header?: React.ReactNode;
  items: { value: string | number; label: string }[]; // Adjusted type
  className?: string;
  classname?: string;
  multiple?: boolean;
  value: (string | number)[];
  handleChange: (vl: any) => void;
}

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const SelectCheckmarks: React.FC<BasicSelectProps> = ({
  label,
  header,
  items,
  className,
  multiple,
  value,
  classname,
  handleChange,
  renderValue,
  ...rest
}) => {
  return (
    <Box className={className}>
      {header}
      <FormControl fullWidth className={className}>
        <AutoCompleteInput
          {...rest}
          multiple
          disableCloseOnSelect
          value={items.filter((el) => value.includes(el.value))}
          onSelectItem={(event: any, newValue: typeof items | null) => {
            handleChange(newValue ? newValue.map((el: any) => el.value) : []);
          }}
          options={items}
          getOptionKey={(option: any) => String(option.value)}
          getOptionLabel={(option: any) => option.label}
          inputProps={{
            placeholder: label,
            "aria-label": label,
            className: "personal",
            ...rest.inputProps,
          }}
          freeSolo
          limitTags={rest?.limitTags || 1}
          renderValue={renderValue ? () => null : undefined}
          renderOption={(props, option, { selected }) => {
            const { key, ...optionProps } = props;
            return (
              <li
                style={{
                  padding: 0,
                }}
                key={key}
                {...optionProps}
              >
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  checked={selected}
                />
                <Box
                  component="span"
                  className={
                    ["multi-select-option-label", classname]
                      .filter(Boolean)
                      .join(" ") || undefined
                  }
                  sx={{
                    display: "block",
                    flex: "1 1 auto",
                    minWidth: 0,
                    width: "auto !important",
                    overflow: "visible !important",
                    overflowWrap: "anywhere",
                    paddingRight: "16px",
                    textOverflow: "clip !important",
                    whiteSpace: "normal !important",
                  }}
                >
                  {option.label}
                </Box>
              </li>
            );
          }}
        />
      </FormControl>
    </Box>
  );
};

export default SelectCheckmarks;
